import {
    YOUTUBE_TRENDS_PENDING,
    YOUTUBE_TRENDS_FULFILLED,
    YOUTUBE_TRENDS_REJECTED,
    YOUTUBE_SUBSCRIBERS_PENDING,
    YOUTUBE_SUBSCRIBERS_FULFILLED,
    YOUTUBE_SUBSCRIBERS_REJECTED,
    HOT_SEARCHES_FULFILLED,
    HOT_SEARCHES_PENDING,
    HOT_SEARCHES_REJECTED,
    TOP_TRENDS_FULFILLED,
    TOP_TRENDS_REJECTED,
    TOP_TRENDS_PENDING,
    GLOBAL_TWITTER_TRENDS_PENDING,
    GLOBAL_TWITTER_TRENDS_FULFILLED,
    GLOBAL_TWITTER_TRENDS_REJECTED,
    LOCAL_TWITTER_TRENDS_PENDING,
    LOCAL_TWITTER_TRENDS_FULFILLED,
    LOCAL_TWITTER_TRENDS_REJECTED,
    TRENDS_OVER_TIME_FULFILLED,
    TRENDS_OVER_TIME_PENDING,
    TRENDS_OVER_TIME_REJECTED,
    GET_COMPARISONS_PENDING,
    GET_COMPARISONS_FULFILLED,
    GET_COMPARISONS_REJECTED,
    TOGGLE_TRENDS_DURATION_SHOW,
    TOGGLE_TRENDS_COUNTRY_SHOW,
    UPDATE_TRENDS_DURATION,
    SET_TRENDS_TAB_INDEX,
    SAVED_SEARCHES_KEYWORD,
    GOOGLE_TRENDS_FOR_KEYWORDS,
} from "../actions/trendsAction";
import { isFulfilled, isPending, isRejected } from "./reducerUtils";
import { toast } from "react-toastify";
import moment from "moment-timezone";

const trendsReducer = (
    state = {
        // country
        showTrendsCountry: false,

        // duration
        showTrendsDuration: false,
        startDateTime: new Date().setHours(0, 0, 0, 0),
        endDateTime: new Date().setHours(23, 59, 59, 999),
        duration: "7",
        rollingDate: false,

        // trends page
        trendsTabIndex: 0,

        //youtube trends
        youtubeTrendsData: undefined,
        youtubeTrendsLoading: true,
        youtubeTrendsRejected: false,

        //youtube subscribers count
        youtubeSubscribersCount: 0,

        //top trends
        topTrends: undefined,
        topTrendsLoading: true,
        topTrendsRejected: false,

        //local twitter trends
        localTwitterTrends: undefined,
        localTwitterTrendsLoading: true,
        localTwitterTrendsRejected: false,

        //global twitter trends
        globalTwitterTrends: undefined,
        globalTwitterTrendsLoading: true,
        globalTwitterTrendsRejected: false,

        //get trends comparisons
        getComparisons: null,
        getComparisonsPending: false,
        getComparisonsRejected: false,

        // trends discovered over time
        trendsOverTime: null,
        trendsOverTimeLoading: true,
        trendsOverTimeRejected: false,

        // trends discovered over time
        hotSearchesData: null,
        hotSearchesLoading: true,
        hotSearchesRejected: false,

        // SavedSearchKeywords
        savedSearchKeywordsData: null,
        savedSearchKeywordsLoading: true,
        savedSearchKeywordsRejected: false,

        // GOOGLE_TRENDS_FOR_KEYWORDS
        googleTrendsForKeywordsData: null,
        googleTrendsForKeywordsLoading: true,
        googleTrendsForKeywordsRejected: false,
    },
    action,
) => {
    switch (action.type) {
        case SET_TRENDS_TAB_INDEX:
            state = {
                ...state,
                trendsTabIndex: action.payload,
            };
            break;
        case YOUTUBE_TRENDS_FULFILLED:
            state = {
                ...state,
                youtubeTrendsData: action.payload,
                youtubeTrendsLoading: false,
            };
            break;
        case YOUTUBE_TRENDS_PENDING:
            state = {
                ...state,
                youtubeTrendsLoading: true,
                youtubeTrendsRejected: false,
            };
            break;
        case YOUTUBE_TRENDS_REJECTED:
            state = {
                ...state,
                youtubeTrendsLoading: false,
                youtubeTrendsRejected: true,
            };
            break;
        case YOUTUBE_SUBSCRIBERS_FULFILLED:
            state = {
                ...state,
                youtubeSubscribersCount: action.payload,
            };
            break;
        case YOUTUBE_SUBSCRIBERS_PENDING:
            state = {
                ...state,
                youtubeSubscribersCount: 0,
            };
            break;
        case YOUTUBE_SUBSCRIBERS_REJECTED:
            state = {
                ...state,
                youtubeSubscribersCount: 0,
            };
            break;
        case HOT_SEARCHES_FULFILLED:
            state = {
                ...state,
                hotSearchesData: action.payload,
                hotSearchesLoading: false,
            };
            break;
        case HOT_SEARCHES_PENDING:
            state = {
                ...state,
                hotSearchesLoading: true,
                hotSearchesRejected: false,
            };
            break;
        case HOT_SEARCHES_REJECTED:
            state = {
                ...state,
                hotSearchesLoading: false,
                hotSearchesRejected: true,
            };
            break;
        case TOP_TRENDS_FULFILLED:
            state = {
                ...state,
                topTrends: action.payload,
                topTrendsLoading: false,
            };
            break;
        case TOP_TRENDS_PENDING:
            state = {
                ...state,
                topTrendsLoading: true,
                topTrendsRejected: false,
            };
            break;
        case TOP_TRENDS_REJECTED:
            state = {
                ...state,
                topTrendsLoading: false,
                topTrendsRejected: true,
            };
            break;
        case GET_COMPARISONS_FULFILLED:
            state = {
                ...state,
                getComparisons: action.payload.data,
                getComparisonsPending: false,
            };
            break;
        case GET_COMPARISONS_PENDING:
            state = {
                ...state,
                getComparisonsPending: true,
                getComparisonsRejected: false,
            };
            break;
        case GET_COMPARISONS_REJECTED:
            state = {
                ...state,
                getComparisonsPending: false,
                getComparisonsRejected: true,
            };
            break;
        case LOCAL_TWITTER_TRENDS_FULFILLED:
            state = {
                ...state,
                localTwitterTrends: action.payload,
                localTwitterTrendsLoading: false,
            };
            break;
        case LOCAL_TWITTER_TRENDS_PENDING:
            state = {
                ...state,
                localTwitterTrendsLoading: true,
                localTwitterTrendsRejected: false,
            };
            break;
        case LOCAL_TWITTER_TRENDS_REJECTED:
            state = {
                ...state,
                localTwitterTrendsLoading: false,
                localTwitterTrendsRejected: true,
            };
            break;
        case GLOBAL_TWITTER_TRENDS_FULFILLED:
            state = {
                ...state,
                globalTwitterTrends: action.payload,
                globalTwitterTrendsLoading: false,
            };
            break;
        case GLOBAL_TWITTER_TRENDS_PENDING:
            state = {
                ...state,
                globalTwitterTrendsLoading: true,
                globalTwitterTrendsRejected: false,
            };
            break;
        case GLOBAL_TWITTER_TRENDS_REJECTED:
            state = {
                ...state,
                globalTwitterTrendsLoading: false,
                globalTwitterTrendsRejected: true,
            };
            break;
        case TRENDS_OVER_TIME_FULFILLED:
            state = {
                ...state,
                trendsOverTime: action.payload.data,
                trendsOverTimeLoading: false,
            };
            break;
        case TRENDS_OVER_TIME_PENDING:
            state = {
                ...state,
                trendsOverTimeLoading: true,
                trendsOverTimeRejected: false,
            };
            break;
        case TRENDS_OVER_TIME_REJECTED:
            state = {
                ...state,
                trendsOverTimeLoading: false,
                trendsOverTimeRejected: true,
            };
            break;
        case isFulfilled(SAVED_SEARCHES_KEYWORD):
            if (action.payload.data.trends.length > 0)
                state = {
                    ...state,
                    savedSearchKeywordsData: action.payload.data.trends,
                    savedSearchKeywordsLoading: false,
                };
            else
                state = {
                    ...state,
                    savedSearchKeywordsData: [],
                    savedSearchKeywordsLoading: false,
                    googleTrendsForKeywordsData: [],
                    googleTrendsForKeywordsLoading: false,
                    googleTrendsForKeywordsRejected: false,
                };
            break;
        case isPending(SAVED_SEARCHES_KEYWORD):
            state = {
                ...state,
                savedSearchKeywordsLoading: true,
                savedSearchKeywordsRejected: false,
                googleTrendsForKeywordsData: null,
                googleTrendsForKeywordsLoading: true,
                googleTrendsForKeywordsRejected: false,
            };
            break;
        case isRejected(SAVED_SEARCHES_KEYWORD):
            state = {
                ...state,
                savedSearchKeywordsLoading: false,
                savedSearchKeywordsRejected: true,
            };
            break;
        case isFulfilled(GOOGLE_TRENDS_FOR_KEYWORDS):
            if (action.payload.data) {
                state = {
                    ...state,
                    googleTrendsForKeywordsData: action.payload.data.default.timelineData,
                    googleTrendsForKeywordsLoading: false,
                };
            } else
                state = {
                    ...state,
                    googleTrendsForKeywordsData: [],
                    googleTrendsForKeywordsLoading: false,
                };

            break;
        case isPending(GOOGLE_TRENDS_FOR_KEYWORDS):
            state = {
                ...state,
                googleTrendsForKeywordsLoading: true,
                googleTrendsForKeywordsRejected: false,
            };
            break;
        case isRejected(GOOGLE_TRENDS_FOR_KEYWORDS):
            state = {
                ...state,
                googleTrendsForKeywordsLoading: false,
                googleTrendsForKeywordsRejected: true,
            };
            break;
        case TOGGLE_TRENDS_DURATION_SHOW: {
            let newShow = action.payload !== undefined ? action.payload : !state.showFilters;
            return { ...state, showTrendsDuration: newShow };
        }
        case TOGGLE_TRENDS_COUNTRY_SHOW: {
            let newShow = action.payload !== undefined ? action.payload : !state.showFilters;
            return { ...state, showTrendsCountry: newShow };
        }
        case UPDATE_TRENDS_DURATION: {
            return {
                ...state,
                duration: action.payload.duration,
                startDateTime: action.payload.startDateTime,
                endDateTime: action.payload.endDateTime,
                rollingDate: action.payload.rollingDate,
            };
        }
        default:
            return state;
    }
    return state;
};

export default trendsReducer;
